<template>
  <div class="wrapper">
    <div class="container">
      <div class="img">
        <img src="../../assets/imgs/pay-success@3x.png" alt />
      </div>
      <h4>
        下单成功
        <small>我们会在48小时内安排发货，如遇法定假日、公休日顺延。给您带来的不便，敬请谅解。祝您购物愉快！</small>
      </h4>
      <div class="btn">
        <van-button plain type="info" @click="handleOrder">查看订单</van-button>
        <van-button type="info" @click="handleDoctor">我的医生</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import jumpCenter from '@/mixins/jumpCenter';

export default {
  mixins: [jumpCenter],
  methods: {
    handleOrder() {
      // this.$router.push({
      //   name: "OrderList"
      // });
      // 这里跳转商城的订单列表
      // 这里的填写订单需要跳转到mall的页面place-order
      // 订单填写的路径，这里后边需要更多的参数
      // 这个页面会有一个rxId
      const orderId = this.$route.query.orderId || '';
      if (orderId) {
        // 跳转商城的订单列表, 但如果是父订单需要跳转到 订单列表中转页
        this.$fetch
          .fetchIsFatherOrder({ orderId })
          .then((res) => {
            if (res === true) {
              this.$router.push({
                name: 'fatherOrderList',
                query: {
                  orderId
                }
              });
              // this.jumpToMallFatherOrderDetail(orderId);
              return;
            }
            this.$router.push({
              name: 'orderDetail',
              params: {
                id: orderId
              },
              query: {
                // 生成的订单号必是父订单
                isFather: true
              }
            });
            // this.jumpToMallOrderDetail(orderId);
          })
          .catch(() => {
            // do something?
          });
      } else {
        this.jumpToMallOrderList();
      }
    },
    handleDoctor() {
      this.$router.push({
        name: 'BindingDoctors'
      });
    }
  }
};
</script>
<style lang="less" scoped>
.wrapper {
  text-align: center;
  height: 100%;
  .container {
    padding: 40px 30px;
    background-color: #fff;
    min-height: 243px;
    > h4 {
      font-size: 18px;
      margin: 0;
      margin-bottom: 20px;
      small {
        display: block;
        color: #999;
        padding-top: 10px;
        font-size: 14px;
        text-align: left;
        line-height: 20px;
      }
    }
    > p {
      color: #666;
      margin-bottom: 24px;
    }
  }
  .btn {
    // display: flex;
    // justify-content: space-between;
    text-align: center;
    button:nth-child(1) {
      margin-right: 12px;
    }
  }
}
.img {
  width: 44px;
  margin: 0 auto 20px;

  > img {
    width: 100%;
  }
}
</style>
